import React from 'react';
import { string, bool } from 'prop-types';
import { Check } from 'components/Icons';
import classnames from 'classnames';

import './Checkbox.scss';

export default function Checkbox({ className, checked }) {
    const rootClassName = classnames('checkbox', className, {
        'checkbox--active': checked,
    });

    return (
        <div className={rootClassName}>
            {checked && <Check className="checkbox__icon" />}
        </div>
    );
}

Checkbox.propTypes = {
    className: string,
    checked: bool,
};

Checkbox.defaultProps = {
    className: null,
    checked: false,
};
